/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import iconUrl from '../ASSETS/images/icon-location.svg';
import { icon } from 'leaflet';

function Map({ ipInfo }) {
	const {
		location: { lat, lng },
	} = ipInfo;

	const position = [lat, lng];
	const zoom = 15;

	function GoToLocation() {
		const map = useMap();
		useEffect(() => {
			map.setView(position, zoom);
		}, [ipInfo]);
		return null;
	}

	const mapIcon = icon({
		iconUrl,
	});

	return (
		<MapContainer center={position} zoom={zoom} scrollWheelZoom zoomControl={false}>
			<TileLayer url="https://api.mapbox.com/styles/v1/emiomacollins/ckqnwdj0c0mz117o31ou1vq40/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiZW1pb21hY29sbGlucyIsImEiOiJja3Fud2F4Z3QwZHIyMnhxbm9ocmhiMHRzIn0.r0hlJrQLQMTFXSaRdV10Mw" />

			<Marker position={position} icon={mapIcon}>
				<Popup> Location </Popup>
			</Marker>

			<GoToLocation />
		</MapContainer>
	);
}

export default Map;
